import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const OeffentlichkeitAbschlussStartUp: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Durchführung des Vorhabens" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default OeffentlichkeitAbschlussStartUp;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0103646078_ions_Und_Marketingmassnahmen,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0244541555_Medien_Medienkooperation_Etc,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0003721694_nanz_Und_Veroeffentlichungen,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
export const getFormStrucOeffentlichkeitAbschlussStartUps = () => {
	return concat(formStruc());
};
